import { loader } from 'graphql.macro'

export default async function updateInvoiceSettings ({ dataLoaders, variables }) {
  const { input } = variables
  const schema = loader('./updateInvoiceSettings.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { input })
  return response.updateInvoiceSettings
}
